import { showPopup } from '@/shared/helpers/telegram/show-popup';

export const showSlowLoadingPopup = (t: (id: string) => string) => {
  showPopup({
    title: t('Slow Loading'),
    message: t(
      'Some regions may experience connection issues. Try alternative network access methods. Need help? Reach out to our support at @PlayDeckSupBot.'
    ),
  });
};
